const scaleValue = (value, scale) =>
  typeof value === 'number' && Number.isFinite(value) ? value * scale : value;

/**
 * When the canvas/image is shown at a different size than when the template was
 * saved, scale annotation geometry so text/shapes stay aligned with the background.
 */
const scaleAnnotationsForDimensions = (
  annotations,
  savedDimensions,
  currentDimensions,
) => {
  if (
    !annotations ||
    !savedDimensions?.width ||
    !savedDimensions?.height ||
    !currentDimensions?.width ||
    !currentDimensions?.height
  ) {
    return annotations;
  }

  const scaleX = currentDimensions.width / savedDimensions.width;
  const scaleY = currentDimensions.height / savedDimensions.height;

  if (
    Math.abs(scaleX - 1) < 0.001 &&
    Math.abs(scaleY - 1) < 0.001
  ) {
    return annotations;
  }

  const uniformFontScale = Math.min(scaleX, scaleY);

  return Object.fromEntries(
    Object.entries(annotations).map(([id, annotation]) => [
      id,
      {
        ...annotation,
        x: scaleValue(annotation.x, scaleX),
        y: scaleValue(annotation.y, scaleY),
        width: scaleValue(annotation.width, scaleX),
        height: scaleValue(annotation.height, scaleY),
        fontSize: scaleValue(annotation.fontSize, uniformFontScale),
        radius: scaleValue(annotation.radius, uniformFontScale),
        radiusX: scaleValue(annotation.radiusX, scaleX),
        radiusY: scaleValue(annotation.radiusY, scaleY),
      },
    ]),
  );
};

export default scaleAnnotationsForDimensions;
